<template>
  <node-view-wrapper class="havet-pretty-anchor-wrapper">
    <a :href="node.attrs.href" :class="node.attrs.class" @click.prevent="onClick">
      <div class="wrapper">
        <div>
          <node-view-content class="cc" />
        </div>
        <div class="chevron" @click="setHref">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M7.4 15.4l4.6-4.6l4.6 4.6L18 14l-6-6l-6 6z"
            />
          </svg>
        </div>
      </div>
    </a>
  </node-view-wrapper>
</template>

<script>
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from '@tiptap/vue-2'

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent,
  },
  data() {
    return {}
  },
  props: nodeViewProps,
  mounted() {
    this.editor.commands.selectTextblockEnd()
  },
  beforeDestroy() {},
  methods: {
    setHref() {
      // eslint-disable-next-line no-alert
      const newHref = prompt('Ange url', this.node.attrs.href)
      this.updateAttributes({
        href: newHref ? newHref : this.node.attrs.href,
      })
    },
    onClick() {
      return false
    },
  },
}
</script>

<style lang="less">
.havet-pretty-anchor {
  cursor: unset !important;
  position: relative;
  padding: 8px 0;
  border-top: 1px solid rgb(27, 84, 117);
  border-bottom: 1px solid rgb(27, 84, 117);
  display: block;
  text-decoration: none;
  .wrapper {
    display: flex;
    justify-content: space-between;
    .chevron {
      transform: rotate(90deg);
      transform-origin: center;
      display: flex;
      align-items: center;
      cursor: pointer !important;
    }
  }
  p {
    font-size: 12px !important;
    line-height: normal !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  strong {
    color: rgb(27, 84, 117);
  }
}
.havet-pretty-anchor-wrapper + .havet-pretty-anchor-wrapper .havet-pretty-anchor {
  border-top: none;
}
</style>
